import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import lowerFirst from 'lodash/lowerFirst';

import { CapsulePropTypes, typeFactory } from 'src/app/popsicle/propTypes';

import { SCHEMAS } from './schemas';

const ConsumerWebPropTypes = cloneDeep(CapsulePropTypes) as ObjectWithUnknownKeys;

forEach(SCHEMAS, (options, schemaName) => {
  const capsuleType = typeFactory(schemaName, options);

  ConsumerWebPropTypes[schemaName] = capsuleType;
  ConsumerWebPropTypes[lowerFirst(schemaName)] = capsuleType; // for convenience
});

export default ConsumerWebPropTypes;
